var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading && !_vm.videoSrc)?_c('v-progress-linear',{attrs:{"indeterminate":"","striped":"","color":"primary"}}):_c('video-player',{staticClass:"video-player-box",attrs:{"options":_vm.playerOptions,"playsinline":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }